import { render, staticRenderFns } from "./PromoNew.vue?vue&type=template&id=100095a9&scoped=true&"
import script from "./PromoNew.vue?vue&type=script&lang=js&"
export * from "./PromoNew.vue?vue&type=script&lang=js&"
import style0 from "./PromoNew.vue?vue&type=style&index=0&id=100095a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100095a9",
  null
  
)

export default component.exports